export default __webpack_public_path__ + "images/0c480a62ecb13ec231267551f3fb03b6-san_jose_mobile.webp";